module.exports = __webpack_public_path__ + "static/img/foticon.cee732b.png";


//////////////////
// WEBPACK FOOTER
// ./static/foticon.png
// module id = pPel
// module chunks = 1